export default __webpack_public_path__ + "static/color-picker-agnostic-color-do-c5c07f9f0028c6f22d380d38c2269d51bf5d1c4e05b859118963ed09fca6e681.png";